import { useEffect } from "react";

export const useDocumentTitle = (title: string | undefined) => {
  useEffect(() => {
    if (title === undefined) {
      return;
    }

    const previousTitle = document.title;

    document.title = title;

    return () => {
      document.title = previousTitle;
    };
  }, [title]);
};
